import script from "./TreeViewDreLinha.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeViewDreLinha.vue?vue&type=script&setup=true&lang=js"

import "./TreeViewDreLinha.vue?vue&type=style&index=0&id=600a483c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-600a483c"]])

export default __exports__